/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 10:38:16
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { xAxisLabelColor, yAxisLabelColor } from "../visualConfig";


// 判断是否为整数的函数
function isInteger(value) {
  return Number.isInteger(value);
}
 
export default ({ label, list = [], color = [] }) => {
  console.log(color);

  return {
    title: {
      text: '',
      textAlign: 'center',
      textStyle: {
        color: '#000',
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    color,
    legend: {
      bottom: '4%',
    },
    grid: {
      left: '1%',
      right: '1%',
      bottom: '10%',
      top: '7%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: label,
      axisLabel: { show: true, rotate: 90, ...xAxisLabelColor, color: '#777' },
    },
    yAxis: {
      type: 'value',
      name: '单位：亿{db|DB}',
      interval: 0.5,
      nameTextStyle: {
        fontSize: 14,
        fontWeight: 'bold',
        color: '#777',
        rich: {
          db: {
            fontSize: 12,
            fontWeight: 'bold',
            fontStyle: 'italic'
          }
        },
      },
  
      // boundaryGap: [0, 0.01],
      axisLabel: { 
        color: '#777',
        ...yAxisLabelColor,
        formatter: function(value) {
          console.log(value)
          if(isInteger(value) && value !== 0) {
            return value + '.0';
          }else{
            return value
          }
        },
      },
      splitLine: { show: false }
    },
    series: list.map((item, index) => ({
      type: 'line',
      name: item.title,
      data: item.list.map(item => item)
    }))
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P36/chart.js